<template>
 <v-container mt-0 fluid>
 
<v-layout align-space-around fill-height  row>
<v-flex sm5>
<v-layout row wrap>
<swatches  v-model="color" />
 <v-flex  pl-2>
<v-text-field v-model="scheduleName" >New Schedule</v-text-field>

</v-flex>
 <v-flex xs2>
      <v-dialog
        ref="dialog"
        v-model="dateModal"
        :return-value.sync="date"
        persistent
        lazy
        full-width
        width="290px"
      >
        <v-text-field
          slot="activator"
          v-model="date"
          label="StartDate"
          prepend-icon="event"
          readonly
        ></v-text-field>
        <v-date-picker v-model="date" scrollable>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="dateModal = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
        </v-date-picker>
        <v-btn flat color="primary" @click="dateModal = false">Cancel</v-btn>
      </v-dialog>
    </v-flex>

<v-flex xs2>
      <v-dialog
        ref="timedialog"
        v-model="timeModal"
        :return-value.sync="time"
        persistent
        lazy
        full-width
        width="290px"
      >
        <v-text-field
          slot="activator"
          v-model="time"
          label="Start Time"
          prepend-icon="access_time"
          readonly
        ></v-text-field>
        <v-time-picker
          v-if="timeModal"
          v-model="time"
          full-width
        >
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="timeModal = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.timedialog.save(time)">OK</v-btn>
        </v-time-picker>
      </v-dialog>
    </v-flex>
    </v-layout>
<v-container 
      id="scroll-target"
      style="height: calc(100vh - 260px)"
      class="scroll-y"
    >
<v-layout >
  <v-flex sm12>
   
  <draggable style="position:relative;" id="mainList" v-model="schedule" :options="{group:'people'}" :move="checkMove"   @change="onChange" >
     <transition-group style="background-color:#eee;min-height:70vh;display:block" >
     
       <!-- <v-card  v-for="element in schedule" :key="element.id" :id="element.id"  :height="mediaHeight(element)"> -->
        <v-card v-for="(element,index) in schedule" :key="element.id+'-'+index" :id=element.id :ref="element.id" :height="mediaHeight(element)" style="min-height:60px;overflow:hidden;" :class="{highlight:currentElement==element}">
            <v-container  @click="currentElement=element" fluid  pt-2 mb-0 :style="'height:90%;background-color:'+element.color+';'">
            <v-layout row wrap fill-height>
            <v-flex xs10 style="margin-bottom:10px;">
             
             {{element.type}} {{element.title}} {{element.name}} Starting:{{element.time}} Duration:{{element.durationText}}
             <div v-if="element.type=='URL'">{{element.link}}</div>
             - {{element.pListIndex}}
             <span v-if="element.pListId">{{getPlaylist(element.pListId).color}}</span>
             </v-flex>
             <v-flex xs1>
               
             <v-btn @click="editdialog=true" flat fab absolute right icon small color="indigo" style="right:50px">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn  @click="deleteItem(element,index)" flat fab absolute right icon small color="red">
              <v-icon>delete</v-icon>
            </v-btn>
               </v-flex>
               
              <v-layout  style="overflow-x:auto;overflow-y:hidden;" fill-height >
               
                 <v-img  v-if="element.type!=='playlist' && element.imageUrl" ma-1 style="width:120px;height:90px;background-color:#333;"
            :src="element.imageUrl"> 
            
            </v-img> 
            <div v-if="element.type=='title'" class="titlePreview" style="min-height:120px;background-color:#333;">
                          <div :class="pTitle" >{{element.title}}</div>
                           <div :class="pSubtitle">{{element.subtitle}}</div>
                            <div :class="pBody">{{element.body}}</div>
                             <div :class="pFooter">{{element.footer}}</div>
            </div>  
            <div v-if="element.type=='playlist'">
            <v-img   v-for="(item,it) in element.items" :key="'itt'+it" ma-1  fill-height style="width:100px;max-height:100px;background-color:#333;"
            :src="getContent(item.id).imageUrl">
            <div v-if="getContent(item.id).type=='title'" class="titlePreview">
                          <div :class="pTitle">{{getContent(item.id).title}}</div>
                           <div :class="pSubtitle">{{getContent(item.id).subtitle}}</div>
                            <div :class="pBody">{{getContent(item.id).body}}</div>
                             <div :class="pFooter">{{getContent(item.id).footer}}</div>
                      </div>
             
            </v-img>
          </div>
             <v-flex xs2>
            
            <div v-if="element.type=='video'" style="text-align:right;padding-top:10px;">Loops:{{element.loops}}</div>
            </v-flex>
            </v-layout>
            
            </v-layout>
             </v-container>
        </v-card>
       
    </transition-group>
    
</draggable>
</v-flex>
</v-layout>
</v-container>
  <v-flex>
    <v-footer style="position:relative;bottom:0px;" slot="footer" >
      <v-layout row>
        <v-flex sm12>
          <div style="line-height: 50px;margin-top: 50px;
    margin-left: 23px;"><b>Duration {{this.secToTime(totalDuration)}}</b></div>
          
          <v-btn  style="float:right;" @click="saveSchedule(false)">Save</v-btn>
          <v-btn v-if="currentSchedule" style="float:right;" @click="saveSchedule(true)">Update</v-btn>
         
          <v-btn  v-if="currentSchedule"style="float:right;" @click="showSchedule=true">Show</v-btn>
          <v-btn  v-if="currentSchedule" style="float:right;" @click="deploySchedule">Deploy</v-btn>
          <v-btn  style="float:right;" @click="clean">Clear</v-btn>
         
          
        </v-flex>
      </v-layout>
    </v-footer>
  </v-flex>
</v-flex>
<v-flex sm6 offset-xs1>
<v-layout>
<v-flex xs12 pl-1 pt-0 mt-0>
<v-btn  v-bind:class="{ 'v-btn--active': mediaMode=='schedule' }" @click="mediaMode='schedule'">Schedules</v-btn>
<v-btn v-bind:class="{ 'v-btn--active': mediaMode=='playlist' }" @click="mediaMode='playlist'">Playlists</v-btn>
<v-btn v-bind:class="{ 'v-btn--active': mediaMode=='media' }" @click="mediaMode='media'">Media</v-btn>
<v-btn v-bind:class="{ 'v-btn--active': mediaMode=='source' }" @click="mediaMode='source'">Sources</v-btn>
</v-flex>

          </v-layout>
<v-container fill-height fluid 
      id="scroll-target2"
      style="height: 75vh"
      class="scroll-y"
    >
<v-layout >
<v-flex sm12>
<div v-if="mediaMode=='schedule'" >
  
        <v-card dark v-for="element in scheduals" :key="element.id"   >
            <v-container  fluid pt-2 mb-2 :style="'background-color:'+element.color+';'">
            <v-layout row wrap>
            <v-flex xs12 style="color:#fff;margin-bottom:10px;" >
              {{element.title}} {{secToTime(element.duration)}} {{element.color}}
              <v-btn @click="editSchedule(element,true)" flat fab absolute right icon small color="#eee" style="right:50px;top: 0px;">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn  @click="deleteSchedule(element.id)" flat fab absolute right icon small color="#eee" style="top: 0px;">
                <v-icon>delete</v-icon>
              </v-btn>
             </v-flex>
              <v-layout style="overflow-x:auto" >
                 
                   <div v-for="(item,key) in element.items"  ma-1 >
                      <div v-if="item">
                          <v-img v-if="getContent(item.id)" :src="getContent(item.id).imageUrl" style="width:120px;height:90px;background-color:#ccc;">
                          <div v-if="getContent(item.id).type=='title'" class="titlePreview">
                          <div class=pTitle>{{getContent(item.id).title}}</div>
                           <div class=pSubtitle>{{getContent(item.id).subtitle}}</div>
                            <div class=pBody>{{getContent(item.id).body}}</div>
                             <div class=pFooter>{{getContent(item.id).footer}}</div>
                      </div>
                          </v-img>
                      </div>
                    </div>
            
            </v-layout>   
            </v-layout>
             </v-container>
        </v-card>
   
</div>
<draggable v-if="mediaMode=='playlist'" v-model="playlists" :options="{group:{ name:'people',  pull:'clone', put:false }}" :move="checkMove"  :clone="clone">
    <transition-group >
        <v-card dark v-for="(element,index) in playlists" :key="element.id+'_'+index"   >
            <v-container  fluid  pt-2 mb-2 :style="'background-color:'+element.color+';'">
            <v-layout row wrap>
            <v-flex xs12 style="color:#fff;margin-bottom:10px;">
              {{element.name}} {{secToTime(element.duration)}} {{element.color}}
             </v-flex>
              <v-layout style="overflow-x:auto" >
           
            <v-img v-for="(item,i) in element.items" :key="'itm2'+i" ma-1 style="width:120px;height:90px;background-color:#333;"
            :src="getContent(item.id).imageUrl "> 
            <div v-if="getContent(item.id).type=='title'" class="titlePreview">
                          <div class=pTitle>{{getContent(item.id).title}}</div>
                           <div class=pSubtitle>{{getContent(item.id).subtitle}}</div>
                            <div class=pBody>{{getContent(item.id).body}}</div>
                             <div class=pFooter>{{getContent(item.id).footer}}</div>
                      </div>
            </v-img>
            
                     
            </v-layout>   
            </v-layout>
             </v-container>
        </v-card>
    </transition-group>
</draggable>
<div v-if="mediaMode=='media'">
 <v-combobox
          v-model="keywordList"
          :items="keywords"
          label="Search by Keyword."
          multiple
          hide-selected
          deletable-chips
          chips
        ></v-combobox>

<draggable  v-model="mediaList" :options="{group:{ name:'people',  pull:'clone', put:false }}" :move="checkMove"  :clone="cloneMedia">
    <transition-group >
        <v-card v-for="(element,index) in mediaList" :key="element.id+'-'+index"  :color="element.color" v-if="matchesKey(element)" >
            <v-container fluid grid-list-sm ma-2 pb-2>
              <v-layout row wrap>
                <v-flex xs4 >
                  <v-img :src="element.imageUrl"
                    >
                    <div v-if="element.type=='title'" class="titlePreview" style="min-height:100px;">
                          <div class=pTitle>{{element.title}}</div>
                           <div class=pSubtitle>{{element.subtitle}}</div>
                            <div class=pBody>{{element.body}}</div>
                             <div class=pFooter>{{element.footer}}</div>
                      </div>
                  </v-img>
                </v-flex>
                  <v-flex xs6>
                    <v-card-text><h4>{{element.title}}</h4>
                      <span v-if="element.type=='web'"> {{element.web}}<br></span>
                      <span v-if="element.type=='video'"> Clip length: {{secToTime(element.duration)}}<br></span> 
                    </v-card-text>
                  </v-flex>
                </v-layout>
                </v-container>
        </v-card>
    </transition-group> 
</draggable>
</div>
<draggable v-if="mediaMode=='source'" v-model="sourceList" :options="{group:{ name:'people',  pull:'clone', put:false }}" :move="checkMove"  :clone="cloneSource">
    <transition-group >
        <v-card v-for="(element,index) in sourceList" :key="element.id+'-'+index" :height="mediaHeight(element)" :color="element.color" >
            <v-container fluid grid-list-sm ma-2>
              <v-layout row wrap>
                <v-flex xs2>
                  <v-icon style="font-size: 60px;">
                    {{element.icon}}
                  </v-icon><br>
                  <div style="width:60px;text-align:center;font-weight:700">{{element.type}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-card-text><h4><span>Title: </span><editable :content="element.title" @update="element.title = $event"></editable></h4>
                      <div v-if="element.type=='URL'"><span>Url: </span><editable :content="element.link" @update="element.link = $event"></editable></div>
                      <div v-if="element.description"><span>Description: </span><editable :content="element.description" @update="element.description = $event"></editable></div>
                      <span v-if="false">Clip length: {{secToTime(element.duration)}}</span>
                      </v-card-text>
                      </v-flex>
                </v-layout>
                </v-container>
        </v-card>
    </transition-group> 
</draggable>
</v-flex>
</v-layout>
</v-container>
</v-flex>
</v-layout>
<v-dialog
      v-model="showSchedule"
      max-width="700"
    >
    
        <v-card>
        <v-card-title class="headline">Schedule Preview
         <v-btn @click="showSchedOptions=!showSchedOptions" flat fab absolute right icon small color="indigo" style="right:10px">
              <v-icon>edit</v-icon>
            </v-btn>
            </v-card-title>
            <div v-if="showSchedOptions" ><span style="margin-left:20px"><b>OPTIONS:</b></span>
             <v-btn flat @click="currentLoadedSchedule.hideTime=!currentLoadedSchedule.hideTime" >
              <v-icon>access_time</v-icon>&nbsp;<span v-if="currentLoadedSchedule.hideTime"> Show Times</span><span v-else> Hide Times</span>
            </v-btn>
            <v-btn flat @click="currentLoadedSchedule.expandPlaylist=!currentLoadedSchedule.expandPlaylist">
              <v-icon>list</v-icon><span v-if="currentLoadedSchedule.expandPlaylist">playlist contracted</span><span v-else>playlist expanded</span>
            </v-btn>
             <v-btn flat @click="makeJson">
              <v-icon>list</v-icon><span >JSON</span>
            </v-btn>
            </div>
        <v-card-text>
           <ScheduleView v-if="currentLoadedSchedule" :schedule="currentLoadedSchedule"></ScheduleView>
      
         
        
        
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="green darken-1"
            flat="flat"
            @click="showSchedule = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
        
    </v-dialog>
<v-dialog
      v-model="editdialog"
      max-width="290"
    >
      <v-card v-if="currentElement">
        <v-card-title class="headline">Edit Details</v-card-title>
        <v-card-text>
          Type:{{currentElement.type}}<br>
          <v-text-field
          v-if="editableDuration(currentElement.type)" 
          label="Duration"
          v-model="currentElement.durationText"
         
        ></v-text-field>
         <v-text-field
          v-if="currentElement.type=='video'" 
          label="Loops"
          v-model="currentElement.loops"
        >
        </v-text-field >
        <p v-if="currentElement.type=='video'">
         
          Duration:{{secToTime(currentElement.duration*currentElement.loops)}}
        </p >
        <p v-if="currentElement.type!='video' && !editableDuration(currentElement.type)">
          Duration:{{secToTime(currentElement.duration)}}
          </p >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="green darken-1"
            flat="flat"
            @click="doEditChanges(currentElement.durationText);editdialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     
  </v-container>
  
</template>

<script>
import draggable from 'vuedraggable'
import Swatches from 'vue-swatches'
import Editable from '../Editable.vue'
import ScheduleView from './ScheduleView.vue';


export default {
  components: {
    draggable,Swatches,Editable, ScheduleView
  },
  data () {
    return {
      showSchedule:false,
      showSchedOptions:false,
      date:null,
      dateModal:false,
      time:"8:00",
      timeModal:false,
      editDuration:111,
      currentElement:null,
      editdialog:false,
      mediaMode:"playlist",
      color: '#1CA085',
      scheduleName:"New Schedule",
      
      schedule:[], 
      sourceList:[{id:"s0",type:"URL",icon:"web_asset",duration:180,title:"",link:"",description:" "},
      
      {id:"s1",type:"Blank",icon:"broken_image",duration:60,title:"Blank",description:" "},
      {id:"s2",type:"Camera",icon:"camera_alt",duration:300,title:"",description:" "},
      {id:"s3",type:"Title",icon:"font_download",duration:20,title:"",description:" "}], 
      heading:'',
      description:'',
      duration:1000,
      totalDuration:0,
      email: '',
      password: '',
      confirmPassword: '',
      elementCount:0,
      keywordList:[],
      keywords: [
          'Animation',
          'MyState',
          'Student',
          'Stories in September',
          'TAC',
          'TAHO',
          'Tasmanian Artist',
          'The Loop',
          'Title',        
          'UTAS',
          'Visual Art',
          'Wide Angle', 
          'Test'
        ],
    }
  },
  created() {
      console.log("USER",this.user);
      if(this.mediaList.length==0){
        this.$store.dispatch('loadContents');
      }
      if(this.playlists.length==0){
        this.$store.dispatch('loadPlaylists');
      }
  },
  mounted(){
    this.adjustTimes();
  },
  
  computed: {
    
    mediaList () {
       return this.$store.getters.loadedContents
     },
    playlists () {
      //console.log("P",this.$store.getters.loadedPlaylists)
       return this.$store.getters.loadedPlaylists
     },
     scheduals(){
      
      return this.$store.getters.loadedSchedules
    },
    currentSchedule(){
      //console.log("P",this.$store.getters.createdKey)
      return this.$store.getters.createdKey   
    },
    currentLoadedSchedule(){
       return this.$store.getters.loadedSchedule(this.currentSchedule)
    },
    
    getLoops () {
      return 3
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      console.log("HAVE A USER");
    }
  },
  methods: {
    makeJson(){
      let pl=[]
      let plindex=[]
      let item
      console.log(this.currentLoadedSchedule,JSON.stringify(this.currentLoadedSchedule))
      if(this.currentLoadedSchedule){
        for (var i in this.currentLoadedSchedule.items){
          item=this.currentLoadedSchedule.items[i]
          if(item.pListIndex){
            if (!plindex.includes(item.pListIndex)){
              pl.push(item.pListId)
              plindex.push(item.pListIndex)
            }
          }
          
        }
        console.log(pl,plindex)
      }

    },
    deleteSchedule(scheduleId){
      console.log("DELETE",scheduleId)
     this.deleteID = scheduleId;
     this.deletedialog = true;
     this.$store.dispatch('deleteSchedule',scheduleId);   
    },
    confirmDelete(){
      console.log("DELETE -",this.deletedialog)
     this.$store.dispatch('deleteSchedule',this.deleteID); 
     this.deletedialog=false;   
    },
    clean(){
        this.schedule=[];
        this.elementCount=0;
        this.$store.commit('setCurrentSchedule',null)
        this.scheduleName="New Shedule";
        this.time="8:00";
        this.date=null;
        this.adjustTimes()
    },
    editSchedule(scheduleList,clean){
     
      if(clean){
        this.clean()
      }
      var self=this
      this.$store.commit('setCurrentSchedule',scheduleList.id); 
      
      
      var schedule
      var item
      var newItem
      var time=this.clockToSec(scheduleList.startTime)
       for(var i in scheduleList.items){
        newItem={}
        console.log("--",i,scheduleList.items[i]);
        this.elementCount++
        schedule=scheduleList.items[i];
        item=this.getContent(schedule.id);
        if(item){
          newItem.tid="clone"+this.elementCount;
          newItem.duration=parseFloat(schedule.duration,10)
          newItem.loops = parseInt(schedule.loops,10) || 1
          newItem.totalDuration= newItem.duration* newItem.loops
          newItem.pListId=schedule.pListId
          newItem.pListIndex=schedule.pListIndex
          newItem.durationText=this.secToTime(newItem.totalDuration)
          newItem.durationText=newItem.durationText || " "
          newItem.loops=schedule.loops
          newItem.imageUrl=item.imageUrl
          newItem.videoUrl=item.videoUrl
          newItem.web=item.web
          newItem.hideS=item.hideS
          newItem.scaleMode=item.scaleMode
          newItem.addTitle=item.addTitle
          newItem.approved=item.approved
          newItem.artist=item.artist
          
          newItem.id=item.id
          newItem.title=item.title
          newItem.type=item.type
          newItem.looping=item.looping
          newItem.description=item.description
          newItem.creatorId=item.creatorId
          newItem.date=item.date
          newItem.title=item.title
          newItem.body=item.body
          newItem.footer=item.footer
          newItem.subtitle=item.subtitle


      /*
      keywords: (...)
      mode: (...)
      rating: (...)
      videoSize: (...)
      */





        newItem.time=this.secToTime(time)
        time+=newItem.totalDuration
        console.log("NEW",item,newItem,time,schedule.pListIndex);
        this.schedule.push(newItem);
        }else{
          console.log("Missing item",scheduleList.items[i])
        }
      }
      this.scheduleName=scheduleList.title;
      this.color=scheduleList.color;
      this.time=scheduleList.startTime;
      this.date=scheduleList.startDate;
      console.log("NEW Schedual",this.schedule,scheduleList);
      this.adjustTimes()
        //this.playlist.push(playlist.items[0]);
       // this.playlist.push(this.rebuild(this.getContent(playlist.items[0].id))
    },
    editableDuration(type){
      if(type=="web" || type=="URL" || type=="Camera" || type=="Blank"){
        return true
      }
      return false
    },
    doEditChanges(changes){
      if(this.currentElement.type!="video"){
          this.currentElement.duration=this.timeToSec(changes);
      }
      if(this.currentElement.loops){
        this.currentElement.totalDuration= this.currentElement.duration* this.currentElement.loops
        this.currentElement.durationText=this.secToTime(this.currentElement.totalDuration)

      }else{
        this.currentElement.totalDuration=this.currentElement.duration=this.timeToSec( this.currentElement.durationText);
      }
      this.adjustTimes()
    },
    deleteItem(element,index){
      console.log("remove",element,index,this.schedule )
      //for (var i = this.schedule.length - 1; i >= 0; --i) {
       // if (this.schedule[i].id == element.id) {
            this.schedule.splice(index,1);
       // }
      //}
      this.adjustTimes()
      console.log("DELETE THIS");
    },
    expand(evt){
      console.log("EXPAND",evt,evt.id)
      console.log(this.$refs)
      console.log(this.$refs[evt.id][0].el)
      this.$refs[evt.id][0].styles.height="200px" 
    },
    deploySchedule(){
      console.log("Deploy SCHED",this.currentSchedule);
       this.$store.dispatch('setControlsGenerate', this.currentSchedule);
    },
    saveSchedule(update){
      console.log("SAVE SCHED",this.schedule);
     
      var sched={duration:this.totalDuration,name:this.scheduleName,color:this.color,startDate:this.date,startTime:this.time};
      sched.items=[];
      
      var plist
      var pListItems
      var count=0;
      var item;
      var newItem;
      var content;
      for(var i=0;i<this.schedule.length;i++){
        newItem={}
        plist=this.schedule[i]
        if(plist.type=="playlist"){
          pListItems=plist.items
           //sched.items.push({type:'groupStart',title:'group'})
           
          for(var j=0;j<pListItems.length;j++){
            count++;
            item=pListItems[j]
            sched.items.push({index:count,duration:parseFloat(item.duration,10),loops:item.loops,id:item.id,type:plist.type,pListIndex:plist.pListIndex,pListId:plist.itemId})
          }
         
        }else{
          count++
          if(plist.itemId){
            content=this.getContent(plist.itemId)
            newItem.id=plist.itemId
          }else{
           content=this.getContent(plist.id)
           newItem.id=plist.id
          }
          newItem.index=count
          newItem.duration=plist.duration
          newItem.loops=parseInt(plist.loops,10) || 1
          newItem.hideS=plist.hideS
          newItem.type=plist.type
          newItem.title=plist.title
          newItem.duration=plist.duration
          
          newItem.pListId=plist.pListId || null
          if(!isNaN(plist.pListIndex)){
            newItem.pListIndex=plist.pListIndex
          }
          if (plist.type=="web" || plist.type=="URL"){
               newItem.link=content.web
               //newItem.description=content.description
          }
          sched.items.push(newItem)
          //sched.items.push({index:count,duration:plist.duration,loops:parseInt(plist.loops,10),id:plist.id,type:plist.type,title:plist.title,duration:plist.duration})
        }
      }
      if(update){
        sched.id=this.currentSchedule
        sched.name=this.scheduleName
        sched.hideTime=this.currentLoadedSchedule.hideTime || false
        sched.expandPlaylist=this.currentLoadedSchedule.expandPlaylist || false
        this.$store.dispatch('updateScheduleData', sched);
      }else{
        this.$store.dispatch('createSchedule', sched);
      }
      
     
    },
    getContent(id){
      //console.log("GET",id,this.$store.getters.loadedContent(id))
      return this.$store.getters.loadedContent(id)
    },
    getPlaylist(id){
      console.log("getPlaylist",id)
       return this.$store.getters.loadedPlaylist(id)
    } ,
    //TODO add totalDuration to all objects
    clone (e1){
      console.log(e1);
      this.elementCount++
      return {id:"clone"+this.elementCount,type:e1.type,title:e1.title,
      name:e1.name,durationText:this.secToTime(e1.duration),duration:e1.duration,totalDuration:e1.duration,
      color:e1.color,time:0,loops:0,items:this.cloneItems(e1.items),itemId:e1.id,hideS:e1.hideS}
      
    },
    cloneItems (items){
      var newItems=[]
      var item
      console.log(items)
      for(var i in items){
        item=items[i]
         console.log("--",item)
        newItems.push({duration:item.duration,id:item.id,loops:item.loops,index:item.index,hideS:item.hideS});
      }
      return newItems
    },
    cloneMedia (e1){
      console.log(e1);
      this.elementCount++
      return {id:"clone"+this.elementCount,type:e1.type,title:e1.title,footer:e1.footer|| null,subtitle:e1.subtitle|| null,name:e1.name,durationText:this.secToTime(e1.duration),duration:e1.duration,totalDuration:e1.duration,color:e1.color,time:0,loops:1,videoUrl:e1.videoUrl,imageUrl:e1.imageUrl,itemId:e1.id,hideS:e1.hideS}
      
    },
    cloneSource (e1){
      console.log("Source",e1);
      this.elementCount++
      return {id:"clone"+this.elementCount,type:e1.type,title:e1.title,name:e1.name,link:e1.link,description:e1.description,durationText:this.secToTime(e1.duration),duration:e1.duration,totalDuration:e1.duration,color:e1.color,time:0,loops:0,videoUrl:e1.videoUrl,imageUrl:e1.imageUrl,itemId:e1.id,hideS:e1.hideS}
      
    },
    onChange(evt){
      console.log("Change",evt)
      var type;
      if(evt.added){
        try{
          type=evt.added.element.type;
          console.log("Change added",type)
          this.currentElement=evt.added.element;
          switch(type){
            case "Blank": this.editdialog=true;
            break;
          }
        }catch(err){
          console.log("Not a Vaild element");
        }
         
      }
      this.adjustTimes();

    },
    
    adjustTimes(){
     
      var time=this.timeToSec(this.time+":00");
      this.totalDuration=0
      console.log("ADJUST TIME",this.time,this.timeToSec(this.time+":00"));
        for(var i=0;i<this.schedule.length;i++){
          this.schedule[i].totalDuration=parseFloat(this.schedule[i].totalDuration,10);
          this.schedule[i].time=this.secToTime(time+ this.totalDuration);
          this.totalDuration+=this.schedule[i].totalDuration;
          console.log("XXX",this.schedule[i])
          if(this.schedule[i].type=="playlist"){
              console.log("PLAYLIST",this.schedule[i])
              this.schedule[i].pListIndex=i;
              for(var item in this.schedule[i].items){
                this.schedule[i].items[item].pListIndex=i
              }
          }
          //this.schedule[i].id="media_"+i; 
          //this.schedule[i] = Object.assign({}, this.schedule[i], { time: this.secToTime(items[i].offsetTop*60) })
          //}
          
        }
        console.log("SCHEDULE",this.schedule)
        
    },
    textChange(){
        console.log("TC",)
        this.adjustTimes()
    },
    cardRef(element){
      return element.id
    },
    mediaHeight (element){
      console.log("HH",element.loops)
      //return (element.totalDuration/10)+"px"
      return "100px"
    },
    
    checkMove (evt){
     // cant drag empty elements
     
      return (evt.draggedContext.element.name!=='');
    },
    
    
    sendMessage (btn) {
      this.$store.dispatch('sendMessage',{heading: this.heading,description: this.description})
      console.log(this.heading)
    },
    sendCommand (btn) {
      this.$store.dispatch('sendCommand',btn)
      console.log(btn)
    },
    onSignin () {
      console.log('email:', this.email)
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed () {
      console.log('Dismissed alert')
      this.$store.dispatch('clearError')
    },
    secToTime (sec) {
      var secs=sec%60;
      var mins=((sec-secs)/60)%60;
      var hrs=(sec-mins*60-secs)/60/60;
      secs=Math.round(secs);
      if(secs<10)secs="0"+secs;
      if(mins<10)mins="0"+mins;
      return hrs+":"+mins+":"+secs;
    },
     timeToSec (time) {
       var times=time.split(":")
      var secs=parseInt(times[2],10)
      var mins=parseInt(times[1],10)
      var hrs=parseInt(times[0],10)
      
      return hrs*60*60+mins*60+secs;
    },
    clockToSec (time) {
      var times=time.split(":")
      var mins=parseInt(times[1],10)
      var hrs=parseInt(times[0],10)
      
      
      return hrs*60*60+mins*60;
    },
    matchesKey(element){
     
      if(this.keywordList.length==0){
        return true;
      }
      if(this.keywordList[0]=="None" && !element.keywords){
        return true;
      }
      if(!element.keywords){
        return false;
      }
      return this.findOne(this.keywordList,element.keywords)
    },
    findOne (haystack, arr) {
            var haystack_lc= haystack.map(function(x) { return x.toLowerCase(); });
            return arr.some(function (v) {
              
                return haystack_lc.indexOf(v.toLowerCase()) >= 0;
            });
    },
  }
}

</script>
<style>
input .inline{
  display:inline;
}
.highlight{
  min-height:20px!important;
  background-color:#afdfc2!important;
  height:auto!important;
  
}
.buttonInput.input-group.input-group--solo {
    margin-left: 10px;
   
}
.buttonInput.input-group.input-group--solo label {
    top: 2px;
}
.buttonInput.input-group.input-group--solo {
    min-height: 26px; 
}
.buttonInput.input-group.input-group--solo .input-group__input{
  padding:0px 16px;
   width:80px;
}
</style>


// WEBPACK FOOTER //
// src/components/Content/Schedule.vue